module.exports = __webpack_public_path__ + "img/f650a3e.png";